module.exports = __webpack_public_path__ + "img/1-2_hybridmaster-1.f71197a3.gif";